import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DataService } from 'src/app/services/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';


@Component({
  selector: 'app-platform',
  templateUrl: './platform.component.html',
  styleUrls: ['./platform.component.scss']
})

export class PlatformComponent implements OnInit {

  constructor(private router: Router, private _ds: DataService,
    private fb: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute) { }

  Ttoken: any

  ngOnInit(): void {
    // this.route.queryParamMap.subscribe(params => {
    //   const token = params.get('token');
    //   this.Ttoken = params.get('token');
    //   if (!token) return;

    //   const decoded = jwtDecode<OrganizerApprovalPayload>(token);

    //   console.log('FULL TOKEN 👉', decoded);

    //   // ✅ THIS IS THE KEY LINE
    //   this.organizer = decoded.organizer;

    //   console.log('ORGANIZER 👉', this.organizer);
    //   console.log('Company 👉', this.organizer.company_name);
    //   console.log('KYC 👉', this.organizer.kyc_status);
    // });
  }

  goToCompanyDetails() {
    this.router.navigate(['/platform-legal'], {
      queryParams: {
      token: this.Ttoken   // ya jo bhi variable me token hai
    }
    });
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login'], { replaceUrl: true });
  }
}
